import { useCallback, useEffect, useState } from "react";
import { getDropDownCurrentStatus } from "../../services/customerFutures";

const useCurrentStatus = () => {
  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getDropDownCurrentStatus();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);
      const transformedOptions = [
        { label: "เลือกทั้งหมด", value: "all" },
        ...objectValue.map((item) => ({
          label: item.dataDetailTh,
          value: item.dataId,
        })),
      ];

      setOptions(transformedOptions);
    }
  }, [setData, setOptions]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data, options];
};

export default useCurrentStatus;
